export abstract class AppConfig {
    baseUrl: string;
}